// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3975) return "static/chunks/3975-9cc3cc4135aeeacd.js";
	if (chunkId === 2547) return "static/chunks/2547-866df86ffff27b4f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3651":"d4b45a17f8321cf8","4492":"da34394152b46d84","5531":"94b1b24d6033eace","6985":"f0a8c233ae53a597","7712":"4ac8b82719a9d51a","8568":"9871fa5b29ff7135"}[chunkId] + ".js";
};